import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

// Global router before each handler [Hook]
router.beforeEach(async (to, _, next) => {
  next(await store.dispatch('moduleWizard/beforeEachCoordinator', {
    name: to.name,
    step: !!to.meta.step,
    verify: to.meta.verify
  }))
})

// Global router after each handler [Hook]
router.afterEach(async (to) => {
  await store.dispatch('moduleWizard/afterEachCoordinator', {
    name: to.name,
    idx: to.meta.step ? to.meta.step.idx : -1 // -1 => this is not wizard step
  })
})

export default router
